export default __webpack_public_path__ + "static/media/selected5.0993dc84.png";